import { HGET, HPOST} from '@/utils/net-work'

const baseUri = '/api'
// 我的收藏列表
function getFavoriteList(params: {page: number; category: number; subject_id: number}, headers) {
    return HPOST(baseUri + '/personal_collect/collect/list', params, headers)
}
// 题目详情
function getQuestionDetail(params: {question_id?: number | string;}, headers) {
    return HGET(baseUri + '/mini_program/question/detail', params, headers)
}
// 相似题接口
function getQuestionTheSame(params: {question_id: number | string; question_ids: any[]}, headers) {
    return HPOST(baseUri + '/mini_program/similar-search', params, headers)
}
// 试卷id转code接口
function paperID2Code(params, headers) {
    return HPOST(baseUri + '/mini_program/paper/share/detail', params, headers)
}
// 试卷详情接口
function getPaperDetail(params, headers) {
    return HPOST(baseUri + '/mini_program/paper/share/detail', params, headers)
}
// 收藏试卷/试题
function collectAction(params, headers) {
    return HPOST(baseUri + '/mini_program/collect_doc', params, headers)
}
// 取消收藏试卷/试题
function cancelCollectAction(params, headers) {
    return HPOST(baseUri + '/mini_program/cancel_collect_doc', params, headers)
}
// 取消收藏试卷/试题
function getCollectList(params, headers) {
    return HGET(baseUri + '/mini_program/collect/list', params, headers)
}
// 微课详情获取题目 todo
function getWeikeQuestions(params, headers) {
    return HGET('/weike-h5/api/video/course/question/MC_10300010397764', params, headers)
}
// 微课详情 todo
function getWeikeInfo(params, headers) {
    return HGET('/weike-h5/api/video/course/detail/MC_10300010397764', params, headers)
}

export {
    getFavoriteList,
    getQuestionDetail,
    getQuestionTheSame,
    paperID2Code,
    getPaperDetail,
    collectAction,
    cancelCollectAction,
    getCollectList,
    getWeikeQuestions,
    getWeikeInfo
}
